import React from 'react';
export default function LogoUSA() {
  return React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    transform: "scale(1.57)"
  }, React.createElement("g", {
    id: "Top-Nav/USA-1",
    transform: "translate(-88.000000, -24.000000)"
  }, React.createElement("g", {
    id: "Logo/USA-1",
    transform: "translate(88.000000, 24.000000)"
  }, React.createElement("g", {
    id: "Group",
    strokeWidth: "1"
  }, React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, React.createElement("path", {
    d: "M0,0.367288964 L0,27.3738304 C0,28.0407267 0.391820827,28.2005613 0.870737827,27.728994 L3.35846423,25.2794456 L6.55863285,22.1652055 C6.64572902,22.079446 6.81768239,22.0461563 6.94082608,22.0461563 L16.7923212,22.0461563 C22.7150848,22.0461563 27.4274579,16.9259365 27.4274579,11.0230782 C27.4274579,5.1202198 22.7186671,0 16.7923212,0 L0.447795231,0 C0.201507854,0 0,0.124781245 0,0.367288964 Z",
    id: "path-1"
  })), React.createElement("path", {
    fill: "#FFFFFF",
    d: "M0,0.367288964 L0,27.3738304 C0,28.0407267 0.391820827,28.2005613 0.870737827,27.728994 L3.35846423,25.2794456 L6.55863285,22.1652055 C6.64572902,22.079446 6.81768239,22.0461563 6.94082608,22.0461563 L16.7923212,22.0461563 C22.7150848,22.0461563 27.4274579,16.9259365 27.4274579,11.0230782 C27.4274579,5.1202198 22.7186671,0 16.7923212,0 L0.447795231,0 C0.201507854,0 0,0.124781245 0,0.367288964 Z",
    id: "path-1"
  }), React.createElement("g", {
    mask: "url(#mask-2)",
    id: "Rectangle",
    fill: "#E43926"
  }, React.createElement("rect", {
    x: "0",
    y: "0",
    width: "28",
    height: "3.5"
  }), React.createElement("rect", {
    x: "0",
    y: "14",
    width: "28",
    height: "3.5"
  }), React.createElement("rect", {
    x: "0",
    y: "7",
    width: "28",
    height: "3.5"
  }), React.createElement("rect", {
    x: "0",
    y: "21",
    width: "28",
    height: "3.5"
  }))), React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#3C61AF",
    x: "0",
    y: "0",
    width: "12.25",
    height: "10.5"
  }), React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: "2.625",
    cy: "2.625",
    r: "1"
  }), React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: "6.125",
    cy: "2.625",
    r: "1"
  }), React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: "4.375",
    cy: "5.25",
    r: "1"
  }), React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: "7.875",
    cy: "5.25",
    r: "1"
  }), React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: "9.625",
    cy: "2.625",
    r: "1"
  }), React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: "2.625",
    cy: "7.875",
    r: "1"
  }), React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: "6.125",
    cy: "7.875",
    r: "1"
  }), React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: "9.625",
    cy: "7.875",
    r: "1"
  }))));
}